import Drawer from "../../../components/ui/Drawer";
import RdaDrawer from "@/custolink-views/asset_frontend/redesigns/RdaDrawer";
import useUiContext from "@/custolink-hooks/useUiContext";
import UserAuthedInfoPart from "@/custolink-views/asset_frontend/account/UserAuthedInfoPart";
import PresentOptionsPart from "@/custolink-views/asset_frontend/account/PresentOptionsPart";
import AssetDrawerScope from "@/custolink-views/asset_frontend/redesigns/AssetDrawerScope";
import { normaliseHex } from "@/custolink-views/asset_frontend/redesigns/theme";
import { useAssetFrontendDesign } from "@/custolink-views/asset_frontend/redesigns/assetFrontendDesign";
import { useTranslation } from "react-i18next";

export default function AccountDrawer(p: {
  open: boolean;
  close: () => void;
  useThisFeatureAlert: boolean;
}) {
  const { t } = useTranslation();
  const uic = useUiContext();
  const accent = normaliseHex(uic.organisationContext.lookAndFeel.assetFrontendBgcolorHex);
  // Shared with the classic pages (AssetFrontendHome, AssetViewClassic): the
  // drawer frame follows the asset-frontend switch so classic visitors still
  // get the old Drawer chrome, and new-design visitors get RdaDrawer.
  const newDesign = useAssetFrontendDesign();
  const DrawerFrame = newDesign ? RdaDrawer : Drawer;

  return (
    <DrawerFrame
      title={t("account.title")}
      isOpen={p.open}
      placement="right"
      width={"100%"}
      onClose={() => p.close()}
      onRequestClose={() => p.close()}
    >
      <AssetDrawerScope accent={accent}>
        {uic.assetFrontendAuthedUser != null ? (
          <UserAuthedInfoPart />
        ) : (
          <PresentOptionsPart useThisFeatureAlert={p.useThisFeatureAlert} />
        )}
      </AssetDrawerScope>
    </DrawerFrame>
  );
}
